import configData from "./config.json";

const URL_KEYS = [
  "URL_AUTH_MAYBANK",
  "URL_SEND_OTP",
  "URL_VERIFY_OTP",
  "GET_FTDATA",
  "URL_SAVE_FT",
  "URL_SUBMIT",
  "URL_ToHomeScreen",
  "URL_SEND_SAVEDETAILS",
];

const SUPPORTED_STATUS = ["PROD", "SIT", "UAT"];

const getResolvedKey = (baseKey, status) => {
  if (status === "PROD") {
    return baseKey;
  }

  return `${baseKey}_${status}`;
};

export const resolveConfigByServerStatus = () => {
  const currentStatus = String(configData.SERVER_STATUS || "PROD").toUpperCase();
  const status = SUPPORTED_STATUS.includes(currentStatus) ? currentStatus : "PROD";

  URL_KEYS.forEach((baseKey) => {
    const resolvedKey = getResolvedKey(baseKey, status);
    const resolvedValue = configData[resolvedKey] || configData[baseKey];

    if (typeof resolvedValue === "string") {
      configData[baseKey] = resolvedValue.trim();
    } else {
      configData[baseKey] = resolvedValue;
    }
  });

  return configData;
};

export default resolveConfigByServerStatus;